import { Link } from '../lib/router';
import { Masthead } from '../components/Masthead';

export default function NotFoundPage() {
  return (
    <div className="shell">
      <Masthead />
      <main className="page">
        <h1>Nothing here</h1>
        <p className="lede">
          That address does not match a meeting. If you were sent a link, check it copied in full —
          the code is sixteen characters.
        </p>
        <p style={{ marginTop: '1.5rem' }}>
          <Link to="/">Back to Vortex</Link>
        </p>
      </main>
    </div>
  );
}
